<script setup lang="ts">
import {toTypedSchema} from '@vee-validate/zod'
import {useField} from 'vee-validate'
import {ZodSchema} from 'zod'

const props = defineProps<{
  name: string
  label: string
  placeholder?: string
  options: string[]
  validation?: ZodSchema
  required?: boolean
}>()

const {handleBlur, value, errorMessage, setValue} = useField<string>(
  props.name,
  props.validation ? toTypedSchema(props.validation) : undefined
)
</script>

<template>
  <FormSelect
    @update:model-value="setValue($event, false)"
    :model-value="value"
    @blur="handleBlur"
    :options="options"
    :name="name"
    :label="label"
    :placeholder="placeholder"
    :error="errorMessage"
    :required="required"
  />
</template>
